<script>
export default {
  props: {
    daySelected: {
      type: Number,
      default: 14,
    },
    filterStartDate: {
      type: Date,
      default: undefined,
    },
    filterEndDate: {
      type: Date,
      default: undefined,
    },
    onDateChange: {
      type: Function,
      default: undefined,
    },
  },
}
</script>
